﻿import React from 'react';
export class GhoreTableUI extends React.Component {
    constructor(props) {
        super(props);

        this.onViewClick = this.onViewClick.bind(this);
        this.onPrizeClick=this.onPrizeClick.bind(this);
        this.onGhoreClick=this.onGhoreClick.bind(this);
    }
    onViewClick(e) {
     //   console.log("view click");
        if (typeof this.props.onViewClick === "function") {
            this.props.onViewClick(e);

        }
    }


    onPrizeClick(e)
    {

   //     console.log("prize click");
        if (typeof this.props.onPrizeClick === "function") {
            this.props.onPrizeClick(e);
        }
    }


    onGhoreClick(e)
    {

   //     console.log("prize click");
        if (typeof this.props.onGhoreClick === "function") {
            this.props.onGhoreClick(e);
        }
    }


    render() {

        if (this.props.data != null && this.props.data.length > 0) {
            var Rows = this.props.data.map(
                (data) =>

                    <tr key={data.ghore.id}>
                        <td >
                            {data.ghore.id}
                        </td>
                        <td>
                            {data.ghore.name}
                        </td>
                        <td>
                            {data.ghore.description}
                        </td>

                        <td>
                            <button onClick={() => this.onPrizeClick(data.ghore.id)} className="btn btn-primary">
                                جوایز
                          </button>
                        </td>


                        <td>
                            <button onClick={() => this.onGhoreClick(data.ghore.id)} className="btn btn-primary">
                                قرعه کشی
                          </button>
                        </td>





                    </tr>



            );
        }
        else {
            Rows = <tr><td colSpan="3">سطری وجود ندارد</td></tr>;
        }

        return (
            <div className="col-lg-12">
                <div className="">

                    <div className="table-responsive ">
                        <table className="table  table-striped text-center">
                            <thead>
                                <tr>

                                    <th >
                                        شناسه
                                </th>
                                    <th>
                                        نام
                                </th>
                                    <th>
                                        توضیحات
                                </th>

                                    <th>

                                    </th>


                                </tr>

                            </thead>
                            <tbody>
                                {Rows}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );

    }
}
/*
function printPrice(x) {


    // console.log("x:" + x);
    if (typeof (x) == "undefined")
        return "";

    if (x == null || x === "")
        return "";

    x = parseInt(x);

    return MytoLocaleString(x);
}

function MytoLocaleString(s) {

    var s1 = s.toLocaleString();
    var p = new Number(Math.floor(s) + 0.1);    // similar value but decimal
    var p1 = p.toLocaleString();
    var index;
    var point;
    for (index = p1.length - 1; index > 0; index--) { // find decimal point in dummy
        point = p1.charAt(index);
        if (point < '0' || point > '9')
            break;
    }
    if (index > 0) {
        index = s1.lastIndexOf(point);          // find last point in string
        if (index > 0)
            s1 = s1.slice(0, index);            // truncate decimal part

        return s1;
    }
    return "";
}
*/


// WEBPACK FOOTER //
// ./src/tables/ghore/GhoreTableUI.js